import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Result, ResultOfT } from 'src/app/shared/models/response/result';
import { DuplicateConfigDetails, SalesOrderHistoryCountModel, SelfSchedulingWrapper, VerifyYourIdentityModel } from 'src/app/shared/models/response/settings/self-scheduling-config-model';
import { InsuranceProvider, NotificationSubTemplateResponseModel } from 'src/app/shared/models/response/settings/self-scheduling-config-model/notification-subtemplate-response-model';
import { BaseService } from 'src/app/shared/services/base.service';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SelfSchedulingConfigService extends BaseService {
  ctrl = 'self-scheduling-config';
  constructor(http: HttpClient, webStorageService: WebStorageService) {
    super(http, webStorageService);
  }

  save(item: SelfSchedulingWrapper): Observable<ResultOfT<DuplicateConfigDetails[]> | Result> {
    return this.post(this.ctrl, item);
  }

  getAll(): Observable<ResultOfT<SelfSchedulingWrapper>> {
    return this.get(this.ctrl);
  }

  GetAllSubTemplate() {
    return this.get<ResultOfT<Array<NotificationSubTemplateResponseModel>>>(this.ctrl + '/GetAllSubTemplate');
  }
  GetAllInsurance() {
    return this.get<ResultOfT<Array<any>>>(this.ctrl + '/GetAllInsurance');
  }
  deleteById(id: number) {
    return this.delete(`${this.ctrl}/${id}`);
  }

  getSalesorderHistoryCount(salesOrderId:number): Observable<ResultOfT<SalesOrderHistoryCountModel>> {
    return this.get<ResultOfT<SalesOrderHistoryCountModel>>('self-scheduling-config/GetSOHistoryCount/' + salesOrderId);
  }

  validateExpireAppointmentLink(strLink: string) {
      return this.get<ResultOfT<boolean>>('self-scheduling-config/ExpirePeriodAppointmentLink?strAppointmentLink=' + strLink);
  }

  validateVerifyYourIdentity(verifyYourIdentityModel: VerifyYourIdentityModel) {
      return this.post<ResultOfT<VerifyYourIdentityModel>>('self-scheduling-config/VerifyYourIdentityOnAppointmentLink', verifyYourIdentityModel);
  }
}
